import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-facebook-fav-icon',
  templateUrl: './facebook-fav-icon.component.html',
  styleUrls: ['./facebook-fav-icon.component.scss']
})
export class FacebookFavIconComponent {
@Input() color: string="#FFFFFF"
@Input() size: string="20px"
@Input() showLabel=false

}